/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createOrderrDraft = /* GraphQL */ `
  mutation CreateOrderrDraft($input: CreateOrderrDraftIn) {
    createOrderrDraft(input: $input) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const addToCart = /* GraphQL */ `
  mutation AddToCart($input: AddToCartIn) {
    addToCart(input: $input) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const removeFromCart = /* GraphQL */ `
  mutation RemoveFromCart($orderrItemGroupId: ID!) {
    removeFromCart(orderrItemGroupId: $orderrItemGroupId) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createRentBusySlotStrDates = /* GraphQL */ `
  mutation CreateRentBusySlotStrDates(
    $rentBusySlotInStrDates: RentBusySlotInStrDates!
  ) {
    createRentBusySlotStrDates(
      rentBusySlotInStrDates: $rentBusySlotInStrDates
    ) {
      id
      mobVersion
      appInstance
      mssId
      dateStart
      dateEnd
      articleId
      productId
      mobOrderrItemGroupId
      mobOrderrId
      mssOrderrItemId
      mssOrderrId
    }
  }
`;
export const initMOB = /* GraphQL */ `
  mutation InitMOB($appInstance: String, $mobVersion: Int) {
    initMOB(appInstance: $appInstance, mobVersion: $mobVersion)
  }
`;
export const initArticles = /* GraphQL */ `
  mutation InitArticles($articleIns: [ArticleIn!]!) {
    initArticles(articleIns: $articleIns) {
      id
      mobVersion
      groups
      appInstance
      mssId
      articleType
      productId
      pointSellId
      title
      description
      articleCountTotal
      articleNumber
      articleNumber2
      size
      sizeUnit
      rentLevel
      rentAgeGroup
      rentGender
      aggItem
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteArticlesAll = /* GraphQL */ `
  mutation DeleteArticlesAll($appInstance: String) {
    deleteArticlesAll(appInstance: $appInstance)
  }
`;
export const deleteArticlesByVersion = /* GraphQL */ `
  mutation DeleteArticlesByVersion($appInstance: String, $mobVersion: Int) {
    deleteArticlesByVersion(appInstance: $appInstance, mobVersion: $mobVersion)
  }
`;
export const updateRentBusySlot = /* GraphQL */ `
  mutation UpdateRentBusySlot($rentBusySlot: RentBusySlotInStrDates!) {
    updateRentBusySlot(rentBusySlot: $rentBusySlot) {
      id
      mobVersion
      appInstance
      mssId
      dateStart
      dateEnd
      articleId
      productId
      mobOrderrItemGroupId
      mobOrderrId
      mssOrderrItemId
      mssOrderrId
    }
  }
`;
export const deleteRentBusySlot = /* GraphQL */ `
  mutation DeleteRentBusySlot($id: ID!) {
    deleteRentBusySlot(id: $id) {
      id
      mobVersion
      appInstance
      mssId
      dateStart
      dateEnd
      articleId
      productId
      mobOrderrItemGroupId
      mobOrderrId
      mssOrderrItemId
      mssOrderrId
    }
  }
`;
export const deleteRentBusySlotAll = /* GraphQL */ `
  mutation DeleteRentBusySlotAll($appInstance: String) {
    deleteRentBusySlotAll(appInstance: $appInstance)
  }
`;
export const deleteRentBusySlotByVersion = /* GraphQL */ `
  mutation DeleteRentBusySlotByVersion($appInstance: String, $mobVersion: Int) {
    deleteRentBusySlotByVersion(
      appInstance: $appInstance
      mobVersion: $mobVersion
    )
  }
`;
export const deleteRentBusySlotByMssOrderr = /* GraphQL */ `
  mutation DeleteRentBusySlotByMssOrderr(
    $appInstance: String
    $mobVersion: Int
    $mssOrderrId: Int
  ) {
    deleteRentBusySlotByMssOrderr(
      appInstance: $appInstance
      mobVersion: $mobVersion
      mssOrderrId: $mssOrderrId
    )
  }
`;
export const deleteRentBusySlotByMssOrderrItem = /* GraphQL */ `
  mutation DeleteRentBusySlotByMssOrderrItem(
    $appInstance: String
    $mobVersion: Int
    $mssOrderrId: Int
    $mssOrderrItemId: Int
  ) {
    deleteRentBusySlotByMssOrderrItem(
      appInstance: $appInstance
      mobVersion: $mobVersion
      mssOrderrId: $mssOrderrId
      mssOrderrItemId: $mssOrderrItemId
    )
  }
`;
export const updateOrderrPickupAndPaymentInfo = /* GraphQL */ `
  mutation UpdateOrderrPickupAndPaymentInfo(
    $orderrId: ID!
    $datePickUp: AWSDateTime!
    $paymentMethod: PaymentMethod!
  ) {
    updateOrderrPickupAndPaymentInfo(
      orderrId: $orderrId
      datePickUp: $datePickUp
      paymentMethod: $paymentMethod
    ) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const checkoutOrderr = /* GraphQL */ `
  mutation CheckoutOrderr($orderrId: ID!, $subjectIn: SubjectIn!) {
    checkoutOrderr(orderrId: $orderrId, subjectIn: $subjectIn) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const debug = /* GraphQL */ `
  mutation Debug($input: String) {
    debug(input: $input)
  }
`;
export const createRentProductRequirement = /* GraphQL */ `
  mutation CreateRentProductRequirement(
    $input: CreateRentProductRequirementInput!
    $condition: ModelRentProductRequirementConditionInput
  ) {
    createRentProductRequirement(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
    }
  }
`;
export const updateRentProductRequirement = /* GraphQL */ `
  mutation UpdateRentProductRequirement(
    $input: UpdateRentProductRequirementInput!
    $condition: ModelRentProductRequirementConditionInput
  ) {
    updateRentProductRequirement(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
    }
  }
`;
export const deleteRentProductRequirement = /* GraphQL */ `
  mutation DeleteRentProductRequirement(
    $input: DeleteRentProductRequirementInput!
    $condition: ModelRentProductRequirementConditionInput
  ) {
    deleteRentProductRequirement(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      rentProductType
      nameDisplayed
      nameRequired
      sexDisplayed
      sexRequired
      ageDisplayed
      ageRequired
      weightDisplayed
      weightRequired
      heightDisplayed
      heightRequired
      shoeSizeDisplayed
      shoeSizeRequired
      rentAbilityLevelDisplayed
      rentAbilityLevelRequired
      createdAt
      updatedAt
    }
  }
`;
export const createMOBConfig = /* GraphQL */ `
  mutation CreateMOBConfig(
    $input: CreateMOBConfigInput!
    $condition: ModelMOBConfigConditionInput
  ) {
    createMOBConfig(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      createdAt
      updatedAt
    }
  }
`;
export const updateMOBConfig = /* GraphQL */ `
  mutation UpdateMOBConfig(
    $input: UpdateMOBConfigInput!
    $condition: ModelMOBConfigConditionInput
  ) {
    updateMOBConfig(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      createdAt
      updatedAt
    }
  }
`;
export const deleteMOBConfig = /* GraphQL */ `
  mutation DeleteMOBConfig(
    $input: DeleteMOBConfigInput!
    $condition: ModelMOBConfigConditionInput
  ) {
    deleteMOBConfig(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      enabled
      enabledSchool
      enabledRent
      companyName
      title
      schoolHeader
      rentHeader
      schoolClaim
      rentClaim
      rentVop
      schoolVop
      schoolBookingOffset
      rentBookingOffset
      checkoutTimeLimit
      showPriceWithoutDPH
      rentDiscountPercent
      schoolDiscountPercent
      email
      phone
      emailNotifLogoUrl
      websiteUrl
      webLogoUrl
      webLogoSmallUrl
      webHeroBgImgUrl
      productImageRatio
      paymentMethods
      currency
      cartStaticInfo
      checkoutStaticInfo
      createdAt
      updatedAt
    }
  }
`;
export const createStaticContent = /* GraphQL */ `
  mutation CreateStaticContent(
    $input: CreateStaticContentInput!
    $condition: ModelStaticContentConditionInput
  ) {
    createStaticContent(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
    }
  }
`;
export const updateStaticContent = /* GraphQL */ `
  mutation UpdateStaticContent(
    $input: UpdateStaticContentInput!
    $condition: ModelStaticContentConditionInput
  ) {
    updateStaticContent(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
    }
  }
`;
export const deleteStaticContent = /* GraphQL */ `
  mutation DeleteStaticContent(
    $input: DeleteStaticContentInput!
    $condition: ModelStaticContentConditionInput
  ) {
    deleteStaticContent(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      title
      icon
      isExternal
      linkUrl
      content
      createdAt
      updatedAt
    }
  }
`;
export const createSkill = /* GraphQL */ `
  mutation CreateSkill(
    $input: CreateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    createSkill(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updateSkill = /* GraphQL */ `
  mutation UpdateSkill(
    $input: UpdateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    updateSkill(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteSkill = /* GraphQL */ `
  mutation DeleteSkill(
    $input: DeleteSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    deleteSkill(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      enabledFrom
      enabledTo
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      schoolFormType
      schoolAgeGroups
      schoolSkillLevelClients
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      createdAt
      updatedAt
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      enabledFrom
      enabledTo
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      schoolFormType
      schoolAgeGroups
      schoolSkillLevelClients
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      createdAt
      updatedAt
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      enabledFrom
      enabledTo
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      images
      sizes
      deposit
      orderNumber
      rentProductType
      rentAvailabilityMode
      schoolFormType
      schoolAgeGroups
      schoolSkillLevelClients
      numberOfPersons
      minNumOfPersons
      maxNumOfPersons
      minLessonLength
      maxLessonLength
      defaultLessonLength
      minLength
      maxLength
      minDailyLength
      maxDailyLength
      defaultDailyLength
      timePreferencesStartTimes
      timePreferencesEnabledMonday
      timePreferencesEnabledTuesday
      timePreferencesEnabledWednesday
      timePreferencesEnabledThursday
      timePreferencesEnabledFriday
      timePreferencesEnabledSaturday
      timePreferencesEnabledSunday
      createdAt
      updatedAt
      skill {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      category {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        orderNumber
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      locations {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      sets {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      productType
      orderNumber
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createProductLocation = /* GraphQL */ `
  mutation CreateProductLocation(
    $input: CreateProductLocationInput!
    $condition: ModelProductLocationConditionInput
  ) {
    createProductLocation(input: $input, condition: $condition) {
      id
      mobVersion
      productId
      locationId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const updateProductLocation = /* GraphQL */ `
  mutation UpdateProductLocation(
    $input: UpdateProductLocationInput!
    $condition: ModelProductLocationConditionInput
  ) {
    updateProductLocation(input: $input, condition: $condition) {
      id
      mobVersion
      productId
      locationId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const deleteProductLocation = /* GraphQL */ `
  mutation DeleteProductLocation(
    $input: DeleteProductLocationInput!
    $condition: ModelProductLocationConditionInput
  ) {
    deleteProductLocation(input: $input, condition: $condition) {
      id
      mobVersion
      productId
      locationId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        nextToken
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        nextToken
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          productId
          locationId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      pointSells {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        nextToken
      }
      pointMeetings {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createPointSell = /* GraphQL */ `
  mutation CreatePointSell(
    $input: CreatePointSellInput!
    $condition: ModelPointSellConditionInput
  ) {
    createPointSell(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      openHoursMondayFrom
      openHoursMondayTo
      openHoursTuesdayFrom
      openHoursTuesdayTo
      openHoursWednesdayFrom
      openHoursWednesdayTo
      openHoursThursdayFrom
      openHoursThursdayTo
      openHoursFridayFrom
      openHoursFridayTo
      openHoursSaturdayFrom
      openHoursSaturdayTo
      openHoursSundayFrom
      openHoursSundayTo
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updatePointSell = /* GraphQL */ `
  mutation UpdatePointSell(
    $input: UpdatePointSellInput!
    $condition: ModelPointSellConditionInput
  ) {
    updatePointSell(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      openHoursMondayFrom
      openHoursMondayTo
      openHoursTuesdayFrom
      openHoursTuesdayTo
      openHoursWednesdayFrom
      openHoursWednesdayTo
      openHoursThursdayFrom
      openHoursThursdayTo
      openHoursFridayFrom
      openHoursFridayTo
      openHoursSaturdayFrom
      openHoursSaturdayTo
      openHoursSundayFrom
      openHoursSundayTo
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deletePointSell = /* GraphQL */ `
  mutation DeletePointSell(
    $input: DeletePointSellInput!
    $condition: ModelPointSellConditionInput
  ) {
    deletePointSell(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      addressName
      addressStreet
      addressCity
      addressPostalCode
      gps
      openHoursMondayFrom
      openHoursMondayTo
      openHoursTuesdayFrom
      openHoursTuesdayTo
      openHoursWednesdayFrom
      openHoursWednesdayTo
      openHoursThursdayFrom
      openHoursThursdayTo
      openHoursFridayFrom
      openHoursFridayTo
      openHoursSaturdayFrom
      openHoursSaturdayTo
      openHoursSundayFrom
      openHoursSundayTo
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointMeeting {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        gps
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
      }
      articles {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          articleType
          productId
          pointSellId
          title
          description
          articleCountTotal
          articleNumber
          articleNumber2
          size
          sizeUnit
          rentLevel
          rentAgeGroup
          rentGender
          aggItem
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createPointMeeting = /* GraphQL */ `
  mutation CreatePointMeeting(
    $input: CreatePointMeetingInput!
    $condition: ModelPointMeetingConditionInput
  ) {
    createPointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const updatePointMeeting = /* GraphQL */ `
  mutation UpdatePointMeeting(
    $input: UpdatePointMeetingInput!
    $condition: ModelPointMeetingConditionInput
  ) {
    updatePointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const deletePointMeeting = /* GraphQL */ `
  mutation DeletePointMeeting(
    $input: DeletePointMeetingInput!
    $condition: ModelPointMeetingConditionInput
  ) {
    deletePointMeeting(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      gps
      createdAt
      updatedAt
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const createSet = /* GraphQL */ `
  mutation CreateSet(
    $input: CreateSetInput!
    $condition: ModelSetConditionInput
  ) {
    createSet(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updateSet = /* GraphQL */ `
  mutation UpdateSet(
    $input: UpdateSetInput!
    $condition: ModelSetConditionInput
  ) {
    updateSet(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteSet = /* GraphQL */ `
  mutation DeleteSet(
    $input: DeleteSetInput!
    $condition: ModelSetConditionInput
  ) {
    deleteSet(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      title
      description
      priceTables {
        numberOfPersons
        priceListType
        dphPercent
        price075
        price05
        price1
        price1_5
        price2
        price2_5
        price3
        price3_5
        price4
        price4_5
        price5
        price5_5
        price6
        price6_5
        price7
        price7_5
        price8
        price8_5
        price9
        price9_5
        price10
        price10_5
        price11
        price11_5
        price12
        price12_5
        price13
        price13_5
        price14
        price14_5
        price15
        price15_5
        price16
        price16_5
        price17
        price17_5
        price18
        price18_5
        price19
        price19_5
        price20
        price20_5
        priceEveryOther
      }
      createdAt
      updatedAt
      products {
        items {
          id
          mobVersion
          groups
          appInstance
          setId
          productId
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createSetProduct = /* GraphQL */ `
  mutation CreateSetProduct(
    $input: CreateSetProductInput!
    $condition: ModelSetProductConditionInput
  ) {
    createSetProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      setId
      productId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const updateSetProduct = /* GraphQL */ `
  mutation UpdateSetProduct(
    $input: UpdateSetProductInput!
    $condition: ModelSetProductConditionInput
  ) {
    updateSetProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      setId
      productId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const deleteSetProduct = /* GraphQL */ `
  mutation DeleteSetProduct(
    $input: DeleteSetProductInput!
    $condition: ModelSetProductConditionInput
  ) {
    deleteSetProduct(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      setId
      productId
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const createArticle = /* GraphQL */ `
  mutation CreateArticle(
    $input: CreateArticleInput!
    $condition: ModelArticleConditionInput
  ) {
    createArticle(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      articleType
      productId
      pointSellId
      title
      description
      articleCountTotal
      articleNumber
      articleNumber2
      size
      sizeUnit
      rentLevel
      rentAgeGroup
      rentGender
      aggItem
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateArticle = /* GraphQL */ `
  mutation UpdateArticle(
    $input: UpdateArticleInput!
    $condition: ModelArticleConditionInput
  ) {
    updateArticle(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      articleType
      productId
      pointSellId
      title
      description
      articleCountTotal
      articleNumber
      articleNumber2
      size
      sizeUnit
      rentLevel
      rentAgeGroup
      rentGender
      aggItem
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteArticle = /* GraphQL */ `
  mutation DeleteArticle(
    $input: DeleteArticleInput!
    $condition: ModelArticleConditionInput
  ) {
    deleteArticle(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      articleType
      productId
      pointSellId
      title
      description
      articleCountTotal
      articleNumber
      articleNumber2
      size
      sizeUnit
      rentLevel
      rentAgeGroup
      rentGender
      aggItem
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const createSubject = /* GraphQL */ `
  mutation CreateSubject(
    $input: CreateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    createSubject(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      owner
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updateSubject = /* GraphQL */ `
  mutation UpdateSubject(
    $input: UpdateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    updateSubject(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      owner
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteSubject = /* GraphQL */ `
  mutation DeleteSubject(
    $input: DeleteSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    deleteSubject(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      cognitoId
      companyName
      name
      surname
      street
      city
      postalCode
      country
      email
      phone
      nationality
      documentType
      documentNumber
      documentValidTo
      ic
      dic
      createdAt
      updatedAt
      owner
      orderrs {
        items {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      createdAt
      updatedAt
      owner
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      createdAt
      updatedAt
      owner
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const deletePayment = /* GraphQL */ `
  mutation DeletePayment(
    $input: DeletePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    deletePayment(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      mssOrderrId
      paymentMethod
      paymentState
      amount
      currency
      transId
      redirectUrl
      createdAt
      updatedAt
      owner
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const createOrderr = /* GraphQL */ `
  mutation CreateOrderr(
    $input: CreateOrderrInput!
    $condition: ModelOrderrConditionInput
  ) {
    createOrderr(input: $input, condition: $condition) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updateOrderr = /* GraphQL */ `
  mutation UpdateOrderr(
    $input: UpdateOrderrInput!
    $condition: ModelOrderrConditionInput
  ) {
    updateOrderr(input: $input, condition: $condition) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteOrderr = /* GraphQL */ `
  mutation DeleteOrderr(
    $input: DeleteOrderrInput!
    $condition: ModelOrderrConditionInput
  ) {
    deleteOrderr(input: $input, condition: $condition) {
      id
      mssId
      mobVersion
      groups
      appInstance
      bookingState
      orderrNumber
      price
      priceWithoutDph
      dph
      deposit
      itemsCount
      expireAt
      datePickUp
      dateReturn
      dateTryOut
      paymentMethod
      description
      rentDiscountPercent
      schoolDiscountPercent
      createdAt
      updatedAt
      pointSell {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        addressName
        addressStreet
        addressCity
        addressPostalCode
        gps
        openHoursMondayFrom
        openHoursMondayTo
        openHoursTuesdayFrom
        openHoursTuesdayTo
        openHoursWednesdayFrom
        openHoursWednesdayTo
        openHoursThursdayFrom
        openHoursThursdayTo
        openHoursFridayFrom
        openHoursFridayTo
        openHoursSaturdayFrom
        openHoursSaturdayTo
        openHoursSundayFrom
        openHoursSundayTo
        createdAt
        updatedAt
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        pointMeeting {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          gps
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      client {
        id
        mobVersion
        groups
        appInstance
        mssId
        cognitoId
        companyName
        name
        surname
        street
        city
        postalCode
        country
        email
        phone
        nationality
        documentType
        documentNumber
        documentValidTo
        ic
        dic
        createdAt
        updatedAt
        owner
        orderrs {
          items {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      payments {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          mssOrderrId
          paymentMethod
          paymentState
          amount
          currency
          transId
          redirectUrl
          createdAt
          updatedAt
          owner
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      orderrItemGroups {
        items {
          id
          mobVersion
          groups
          appInstance
          mssId
          subjectProfile {
            name
            weight
            height
            shoeSize
            age
            gender
            rentAbilityLevel
          }
          description
          itemsCount
          numberOfPersons
          length
          priceListType
          dateStart
          dateEnd
          datePickUp
          dateReturn
          dateTryOut
          price
          priceWithoutDph
          priceBeforeDiscount
          priceBeforeDiscountWithoutDph
          discountPercent
          dph
          dphPercent
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          set {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          orderr {
            id
            mssId
            mobVersion
            groups
            appInstance
            bookingState
            orderrNumber
            price
            priceWithoutDph
            dph
            deposit
            itemsCount
            expireAt
            datePickUp
            dateReturn
            dateTryOut
            paymentMethod
            description
            rentDiscountPercent
            schoolDiscountPercent
            createdAt
            updatedAt
            owner
          }
          owner
          orderrItems {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createOrderrItemGroup = /* GraphQL */ `
  mutation CreateOrderrItemGroup(
    $input: CreateOrderrItemGroupInput!
    $condition: ModelOrderrItemGroupConditionInput
  ) {
    createOrderrItemGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfile {
        name
        weight
        height
        shoeSize
        age
        gender
        rentAbilityLevel
      }
      description
      itemsCount
      numberOfPersons
      length
      priceListType
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateOrderrItemGroup = /* GraphQL */ `
  mutation UpdateOrderrItemGroup(
    $input: UpdateOrderrItemGroupInput!
    $condition: ModelOrderrItemGroupConditionInput
  ) {
    updateOrderrItemGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfile {
        name
        weight
        height
        shoeSize
        age
        gender
        rentAbilityLevel
      }
      description
      itemsCount
      numberOfPersons
      length
      priceListType
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteOrderrItemGroup = /* GraphQL */ `
  mutation DeleteOrderrItemGroup(
    $input: DeleteOrderrItemGroupInput!
    $condition: ModelOrderrItemGroupConditionInput
  ) {
    deleteOrderrItemGroup(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      mssId
      subjectProfile {
        name
        weight
        height
        shoeSize
        age
        gender
        rentAbilityLevel
      }
      description
      itemsCount
      numberOfPersons
      length
      priceListType
      dateStart
      dateEnd
      datePickUp
      dateReturn
      dateTryOut
      price
      priceWithoutDph
      priceBeforeDiscount
      priceBeforeDiscountWithoutDph
      discountPercent
      dph
      dphPercent
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      location {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        pointSells {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          nextToken
        }
        pointMeetings {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      set {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        createdAt
        updatedAt
        products {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderr {
        id
        mssId
        mobVersion
        groups
        appInstance
        bookingState
        orderrNumber
        price
        priceWithoutDph
        dph
        deposit
        itemsCount
        expireAt
        datePickUp
        dateReturn
        dateTryOut
        paymentMethod
        description
        rentDiscountPercent
        schoolDiscountPercent
        createdAt
        updatedAt
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        client {
          id
          mobVersion
          groups
          appInstance
          mssId
          cognitoId
          companyName
          name
          surname
          street
          city
          postalCode
          country
          email
          phone
          nationality
          documentType
          documentNumber
          documentValidTo
          ic
          dic
          createdAt
          updatedAt
          owner
          orderrs {
            nextToken
          }
        }
        payments {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            mssOrderrId
            paymentMethod
            paymentState
            amount
            currency
            transId
            redirectUrl
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      orderrItems {
        items {
          id
          mobVersion
          groups
          appInstance
          language
          skillLevelClient
          sameInstructorRequired
          numberOfHoursRequired
          lessons {
            mobVersion
            groups
            appInstance
            mssId
            timeFrom
            timeTo
            timeLength
            mssWorkDayId
          }
          createdAt
          updatedAt
          product {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            enabledFrom
            enabledTo
            images
            sizes
            deposit
            orderNumber
            rentProductType
            rentAvailabilityMode
            schoolFormType
            schoolAgeGroups
            schoolSkillLevelClients
            numberOfPersons
            minNumOfPersons
            maxNumOfPersons
            minLessonLength
            maxLessonLength
            defaultLessonLength
            minLength
            maxLength
            minDailyLength
            maxDailyLength
            defaultDailyLength
            timePreferencesStartTimes
            timePreferencesEnabledMonday
            timePreferencesEnabledTuesday
            timePreferencesEnabledWednesday
            timePreferencesEnabledThursday
            timePreferencesEnabledFriday
            timePreferencesEnabledSaturday
            timePreferencesEnabledSunday
            createdAt
            updatedAt
          }
          article {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          orderrItemGroup {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const createOrderrItem = /* GraphQL */ `
  mutation CreateOrderrItem(
    $input: CreateOrderrItemInput!
    $condition: ModelOrderrItemConditionInput
  ) {
    createOrderrItem(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      language
      skillLevelClient
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
      }
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      article {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfile {
          name
          weight
          height
          shoeSize
          age
          gender
          rentAbilityLevel
        }
        description
        itemsCount
        numberOfPersons
        length
        priceListType
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          createdAt
          updatedAt
          products {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        owner
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
export const updateOrderrItem = /* GraphQL */ `
  mutation UpdateOrderrItem(
    $input: UpdateOrderrItemInput!
    $condition: ModelOrderrItemConditionInput
  ) {
    updateOrderrItem(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      language
      skillLevelClient
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
      }
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      article {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfile {
          name
          weight
          height
          shoeSize
          age
          gender
          rentAbilityLevel
        }
        description
        itemsCount
        numberOfPersons
        length
        priceListType
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          createdAt
          updatedAt
          products {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        owner
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
export const deleteOrderrItem = /* GraphQL */ `
  mutation DeleteOrderrItem(
    $input: DeleteOrderrItemInput!
    $condition: ModelOrderrItemConditionInput
  ) {
    deleteOrderrItem(input: $input, condition: $condition) {
      id
      mobVersion
      groups
      appInstance
      language
      skillLevelClient
      sameInstructorRequired
      numberOfHoursRequired
      lessons {
        mobVersion
        groups
        appInstance
        mssId
        timeFrom
        timeTo
        timeLength
        mssWorkDayId
      }
      createdAt
      updatedAt
      product {
        id
        mobVersion
        groups
        appInstance
        mssId
        title
        description
        productType
        enabledFrom
        enabledTo
        priceTables {
          numberOfPersons
          priceListType
          dphPercent
          price075
          price05
          price1
          price1_5
          price2
          price2_5
          price3
          price3_5
          price4
          price4_5
          price5
          price5_5
          price6
          price6_5
          price7
          price7_5
          price8
          price8_5
          price9
          price9_5
          price10
          price10_5
          price11
          price11_5
          price12
          price12_5
          price13
          price13_5
          price14
          price14_5
          price15
          price15_5
          price16
          price16_5
          price17
          price17_5
          price18
          price18_5
          price19
          price19_5
          price20
          price20_5
          priceEveryOther
        }
        images
        sizes
        deposit
        orderNumber
        rentProductType
        rentAvailabilityMode
        schoolFormType
        schoolAgeGroups
        schoolSkillLevelClients
        numberOfPersons
        minNumOfPersons
        maxNumOfPersons
        minLessonLength
        maxLessonLength
        defaultLessonLength
        minLength
        maxLength
        minDailyLength
        maxDailyLength
        defaultDailyLength
        timePreferencesStartTimes
        timePreferencesEnabledMonday
        timePreferencesEnabledTuesday
        timePreferencesEnabledWednesday
        timePreferencesEnabledThursday
        timePreferencesEnabledFriday
        timePreferencesEnabledSaturday
        timePreferencesEnabledSunday
        createdAt
        updatedAt
        skill {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        category {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          orderNumber
          createdAt
          updatedAt
          products {
            nextToken
          }
        }
        locations {
          items {
            id
            mobVersion
            productId
            locationId
            createdAt
            updatedAt
          }
          nextToken
        }
        sets {
          items {
            id
            mobVersion
            groups
            appInstance
            setId
            productId
            createdAt
            updatedAt
          }
          nextToken
        }
        articles {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            articleType
            productId
            pointSellId
            title
            description
            articleCountTotal
            articleNumber
            articleNumber2
            size
            sizeUnit
            rentLevel
            rentAgeGroup
            rentGender
            aggItem
            createdAt
            updatedAt
          }
          nextToken
        }
        orderrItemGroups {
          items {
            id
            mobVersion
            groups
            appInstance
            mssId
            description
            itemsCount
            numberOfPersons
            length
            priceListType
            dateStart
            dateEnd
            datePickUp
            dateReturn
            dateTryOut
            price
            priceWithoutDph
            priceBeforeDiscount
            priceBeforeDiscountWithoutDph
            discountPercent
            dph
            dphPercent
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      article {
        id
        mobVersion
        groups
        appInstance
        mssId
        articleType
        productId
        pointSellId
        title
        description
        articleCountTotal
        articleNumber
        articleNumber2
        size
        sizeUnit
        rentLevel
        rentAgeGroup
        rentGender
        aggItem
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        pointSell {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          addressName
          addressStreet
          addressCity
          addressPostalCode
          gps
          openHoursMondayFrom
          openHoursMondayTo
          openHoursTuesdayFrom
          openHoursTuesdayTo
          openHoursWednesdayFrom
          openHoursWednesdayTo
          openHoursThursdayFrom
          openHoursThursdayTo
          openHoursFridayFrom
          openHoursFridayTo
          openHoursSaturdayFrom
          openHoursSaturdayTo
          openHoursSundayFrom
          openHoursSundayTo
          createdAt
          updatedAt
          location {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          pointMeeting {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            gps
            createdAt
            updatedAt
          }
          articles {
            nextToken
          }
          orderrs {
            nextToken
          }
        }
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      orderrItemGroup {
        id
        mobVersion
        groups
        appInstance
        mssId
        subjectProfile {
          name
          weight
          height
          shoeSize
          age
          gender
          rentAbilityLevel
        }
        description
        itemsCount
        numberOfPersons
        length
        priceListType
        dateStart
        dateEnd
        datePickUp
        dateReturn
        dateTryOut
        price
        priceWithoutDph
        priceBeforeDiscount
        priceBeforeDiscountWithoutDph
        discountPercent
        dph
        dphPercent
        createdAt
        updatedAt
        product {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          productType
          enabledFrom
          enabledTo
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          images
          sizes
          deposit
          orderNumber
          rentProductType
          rentAvailabilityMode
          schoolFormType
          schoolAgeGroups
          schoolSkillLevelClients
          numberOfPersons
          minNumOfPersons
          maxNumOfPersons
          minLessonLength
          maxLessonLength
          defaultLessonLength
          minLength
          maxLength
          minDailyLength
          maxDailyLength
          defaultDailyLength
          timePreferencesStartTimes
          timePreferencesEnabledMonday
          timePreferencesEnabledTuesday
          timePreferencesEnabledWednesday
          timePreferencesEnabledThursday
          timePreferencesEnabledFriday
          timePreferencesEnabledSaturday
          timePreferencesEnabledSunday
          createdAt
          updatedAt
          skill {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            createdAt
            updatedAt
          }
          category {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            productType
            orderNumber
            createdAt
            updatedAt
          }
          locations {
            nextToken
          }
          sets {
            nextToken
          }
          articles {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
          orderrItems {
            nextToken
          }
        }
        location {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          createdAt
          updatedAt
          products {
            nextToken
          }
          pointSells {
            nextToken
          }
          pointMeetings {
            nextToken
          }
          orderItemGroups {
            nextToken
          }
        }
        set {
          id
          mobVersion
          groups
          appInstance
          mssId
          title
          description
          priceTables {
            numberOfPersons
            priceListType
            dphPercent
            price075
            price05
            price1
            price1_5
            price2
            price2_5
            price3
            price3_5
            price4
            price4_5
            price5
            price5_5
            price6
            price6_5
            price7
            price7_5
            price8
            price8_5
            price9
            price9_5
            price10
            price10_5
            price11
            price11_5
            price12
            price12_5
            price13
            price13_5
            price14
            price14_5
            price15
            price15_5
            price16
            price16_5
            price17
            price17_5
            price18
            price18_5
            price19
            price19_5
            price20
            price20_5
            priceEveryOther
          }
          createdAt
          updatedAt
          products {
            nextToken
          }
          orderrItemGroups {
            nextToken
          }
        }
        orderr {
          id
          mssId
          mobVersion
          groups
          appInstance
          bookingState
          orderrNumber
          price
          priceWithoutDph
          dph
          deposit
          itemsCount
          expireAt
          datePickUp
          dateReturn
          dateTryOut
          paymentMethod
          description
          rentDiscountPercent
          schoolDiscountPercent
          createdAt
          updatedAt
          pointSell {
            id
            mobVersion
            groups
            appInstance
            mssId
            title
            description
            addressName
            addressStreet
            addressCity
            addressPostalCode
            gps
            openHoursMondayFrom
            openHoursMondayTo
            openHoursTuesdayFrom
            openHoursTuesdayTo
            openHoursWednesdayFrom
            openHoursWednesdayTo
            openHoursThursdayFrom
            openHoursThursdayTo
            openHoursFridayFrom
            openHoursFridayTo
            openHoursSaturdayFrom
            openHoursSaturdayTo
            openHoursSundayFrom
            openHoursSundayTo
            createdAt
            updatedAt
          }
          client {
            id
            mobVersion
            groups
            appInstance
            mssId
            cognitoId
            companyName
            name
            surname
            street
            city
            postalCode
            country
            email
            phone
            nationality
            documentType
            documentNumber
            documentValidTo
            ic
            dic
            createdAt
            updatedAt
            owner
          }
          payments {
            nextToken
          }
          owner
          orderrItemGroups {
            nextToken
          }
        }
        owner
        orderrItems {
          items {
            id
            mobVersion
            groups
            appInstance
            language
            skillLevelClient
            sameInstructorRequired
            numberOfHoursRequired
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
